import { h } from 'preact'
import Moment from 'moment'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Project = (props) => {

    let project = props.project
    let title = project.title.rendered
    let branches = project.branch_names
    let link = project.link
    let excerpt = project.excerpt.rendered
    let raw_date = project.date
    let date = Moment(raw_date).format('DD/MM/YYYY')
    let feat_image = project.feat_image

    let text_show = 'Bekijk'

    if (props.language == 'en') {
        text_show = 'View'
        date = Moment(raw_date).format('MM/DD/YYYY')
    }

    return (
        <div className="c-recent-projects__col">
            <div className="c-recent-project u-flex"
                 data-toggle="modal"
                 data-target={'#project-modal-' + project.id}>
                <div className="c-recent-project__image-container">
                    <div className="c-recent-project__image-link"
                         dangerouslySetInnerHTML={{ __html: feat_image }} />
                </div>
                <div className="c-recent-project__content-container">
                    <div className="c-recent-project__link">
                        <h4 className="c-recent-project__title"
                            dangerouslySetInnerHTML={{ __html: title }} />
                        <p className="c-recent-project__excerpt"
                           dangerouslySetInnerHTML={{ __html: excerpt }} />
                        <div className="c-recent-project__footer u-flex u-flex-sb">
                            <div className="c-recent-project__branches">
                                {
                                    branches.map((branch) => {
                                        return (
                                            <span className="c-recent-project__branch">{'#' + branch}</span>
                                        )
                                    })
                                }
                            </div>
                            <div className="c-recent-project__icon-container">
                                Lees meer <i className="fas fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Project

// WEBPACK FOOTER //
// ./src/js/projects/components/Project.js
